<div class="m-0 pb-4 mt-3">
  <div *ngIf="data?.export" class="col-12 mb-1 p-0" [innerHtml]="innerHtml"></div>
  <app-image-upload-viewer [imageUrl]="imageUrl" orientation="square" (emitSelectedFile)="imageChange($event)"
    (imageLoaded)="emitExportEvent($event)"></app-image-upload-viewer>
</div>
